// Google Analytics 4 event helpers.
// The gtag base snippet (G-VDQ7V0PV3M) is loaded in public/index.html.
// These wrappers fire custom events; they no-op safely if gtag isn't available.

export const track = (event, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
};

// Manual SPA page_view (router changes don't reload the page).
export const trackPageView = (path) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
};
